import { FastForward } from 'lucide-react';
import { useSimuliertBis } from '../../lib/simulationsdatum';
import { formatDate } from '../../lib/dateFormat';

/**
 * Testsystem: Der gewählte Standort ist vorgespult. Alles, was hier „heute“, „fällig“
 * oder „läuft“ heißt, bezieht sich auf das Simulationsdatum (docs/simulation-plan.md).
 */
export function SimulationsBanner() {
  const bis = useSimuliertBis();
  if (!bis) return null;
  return (
    <div
      role="status"
      className="mb-4 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
    >
      <FastForward className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        Simulation: Dieser Standort steht auf dem <strong>{formatDate(bis)}</strong>. Fristen,
        Fälligkeiten und Termine beziehen sich auf diesen Tag.
      </span>
    </div>
  );
}
